import { Icon, IconsMap } from '@nx-frontend/shared/ui/icon';
import { Org } from '@nx-frontend/shared/types';
import { getBoxFileUrl } from '@nx-frontend/shared/utils';

export type OrganizationIconSize = 'small' | 'medium';

const getOrganizationImage = (organization: Org) => {
  if (!organization) {
    return null;
  }
  if (!organization.smallLogoStoredFileUUID) {
    return null;
  }
  return getBoxFileUrl(organization.smallLogoStoredFileUUID, { width: 64, height: 64 });
};

const getDefaultOrgIcon = (defaultIconWrapper = true) => {
  return defaultIconWrapper ? (
    <div className="w-7 h-7 bg-neutral-200 flex flex-col justify-center items-center rounded-full">
      <Icon icon={IconsMap.BUILDING} className="text-neutral-500 w-4 h-4" />
    </div>
  ) : (
    <Icon icon={IconsMap.BUILDING} className="text-neutral-500 w-4 h-4" />
  );
};

export const organizationImage = (
  organization: Org,
  {
    addStyles = '',
    size = 28,
    defaultIconWrapper = true,
  }: { addStyles?: string; size?: number; defaultIconWrapper?: boolean },
  isDashboardOrg?: boolean
) => {
  const orgImage = getOrganizationImage(organization);
  if (orgImage) {
    return <img src={orgImage as string} alt="" width={size} height={size} className={addStyles} />;
  }
  if (isDashboardOrg) {
    return getOrganizationIcon(organization);
  } else {
    return getDefaultOrgIcon(defaultIconWrapper);
  }
};

export const getOrganizationIcon = (organzation: Org, size: OrganizationIconSize = 'medium') => {
  const organizationeLetter = organzation.title ? organzation.title.slice(0, 2).toUpperCase() : '?';
  if (!['small', 'medium'].includes(size)) {
    size = 'medium';
  }
  if (size === 'small') {
    return (
      <div className="bg-neutral-800 flex flex-col justify-center w-4 h-4 text-center rounded-[3px]">
        <span className="text-white text-[8px] font-normal object-center">{organizationeLetter}</span>
      </div>
    );
  }
  // medium size
  return (
    <div className="bg-neutral-800 flex flex-col items-center justify-center w-[24px] h-[24px] rounded-[3px]">
      <span className="text-white text-[12px] font-normal object-center">{organizationeLetter}</span>
    </div>
  );
};
